// This function allow to reference async chunks and chunks that the entrypoint depends on
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + {"636":"a6984c19f329275f","7607":"d50abc0f8cda346d"}[chunkId] + ".css";
};